/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'VirtualMachine';
export const filterTitle = t`Virtual Machine`;
export const entityType = ENTITY_TYPES.VIRTUAL_MACHINE;

export function useVirtualMachine() {
    return useEntity(filterId);
}

export function useVirtualMachineName() {
    return useEntityName(filterId);
}

const columns = [
    {
        title: 'Name',
        mapping: 'name',
        flex: 1,
        minWidth: 250,
        sortable: true,
        resizable: false,
    },
    {
        title: 'IP Address',
        width: 150,
        flex: 1,
        sortable: true,
        mapping: 'ipAddress',
    },
];

const dataSourceParams = {
    entityFields: ['name', 'ipAddress'],
};

function VirtualMachineFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns, dataSourceParams, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

VirtualMachineFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

VirtualMachineFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/vmware-vm-detail',
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(VirtualMachineFilter);
